import Cta from "./Lot/Cta";
import Images from "./Lot/Images";
import Info from "./Lot/Info";
import useLot from "./Lot/useLot";

type Props = {
  logged_in: boolean;
  recaptcha_key: string;
  locale: Locale;
  lot: Lot.Lot;
  routes: Lot.Routes;
  strings: Lot.Localizations;
};

export default function Lot(props: Props) {
  const { strings } = props;

  const lot = useLot(props.lot, props.routes.backend, props.logged_in);

  return (
    <div className="lot">
      <Images
        images={lot.images}
        strings={strings}
        title={lot.title}
        artist_name={lot.artist_name}
        artist_lifespan={lot.artist_lifespan}
        object_type={lot.object_type}
        year={lot.year}
      />

      <div className="content">
        <Info lot={lot} strings={strings} />
        <Cta
          loggedIn={props.logged_in}
          lot={lot}
          recaptcha_key={props.recaptcha_key}
          locale={props.locale}
          routes={props.routes}
          strings={strings}
        />
      </div>

      {(lot.video_embed || lot.body) && (
        <div className="more">
          {lot.video_embed && (
            <div
              className="video-embed"
              // eslint-disable-next-line @eslint-react/dom-no-dangerously-set-innerhtml
              dangerouslySetInnerHTML={{ __html: lot.video_embed }}
            />
          )}
          {lot.body && (
            <div
              className="body"
              // eslint-disable-next-line @eslint-react/dom-no-dangerously-set-innerhtml
              dangerouslySetInnerHTML={{ __html: lot.body }}
            />
          )}
        </div>
      )}
    </div>
  );
}
